/** Editor i18n catalog: cardDetails - the card details page (spec #316). English is the key source; German uses "du" and real umlauts. */
import { defineMessages } from "../core.ts";

export const cardDetails = defineMessages(
  {
    back: "Dashboard",
    acceptedOn: "{brand} · accepted {when}",
    chipInProduction: "In production",
    chipInRevision: "In revision · round {round}",
    chipRequested: "★ The client asked for you",

    unavailableTitle: "This card is not available",
    unavailableBody: "It may have moved on, or it is not yours.",

    briefing: "Briefing",
    copyBriefing: "Copy briefing",
    copiedBriefing: "Copied",
    copyBriefingFailed: "Copy failed",
    openAllSections: "Open all",
    closeAllSections: "Close all",
    versionNote: "Version note",
    noteFromAditor: "Note from Aditor for {brand}",
    watchLoom: "Watch",

    assets: "Assets and links",
    noAssets: "No assets or links on this card.",
    attached: "Attached to the card",

    additionalInfo: "Additional info",
    recentlyDelivered: "Recently delivered {brand} cards",

    yourCard: "Your card",
    rateStatic: "Static rate",
    rateBrandFlat: "{brand} flat rate",
    rateLocked: "Your rate for this card",
    ratePending: "Price coming",
    typeFact: "Type",
    lengthFact: "Length",
    languageFact: "Language",
    lengthSeconds: "~{seconds}s",
    lengthHooks: "{hooks} x ~{seconds}s",

    leftHours: "{hours}h left",
    leftUnderHour: "under 1h left",
    overdue: "Overdue",
    graceLeft: "Upload grace, {minutes} min left",
    dueOn: "Due {when}",
    revisionDueOn: "Revision due {when}",
    handedInOnTime: "Handed in {when}, on time",
    handedInLate: "Handed in {when}, late",

    checklistTitle: "Checklist for this card",
    checklistCount: "{done} of {total}",
    requestedChangesTitle: "Requested changes",
    requestedChangesRound: "Round {round}",
    clientComments: "{brand}'s comments in FreeFrame ↗",

    feedbackTitle: "Client comments on this card",
    feedbackLoading: "Loading the client's comments…",
    feedbackEmpty: "No client comments on this card yet.",
    feedbackUnavailable: "The client's comments could not be loaded right now. Reload the page in a moment.",
    feedbackFreeframeHint: "What the client marked up in FreeFrame is under Requested changes.",

    submit: "Submit for review ↗",
    submitting: "Opening…",
    giveBack: "Give back",
    givingBack: "Giving back…",
    uploadNewVersion: "Upload new version ↗",
    uploading: "Opening…",
    noHandinLink: "No hand-in link for this card yet - ask Ops.",

    hintProduction: "Submit opens this card's own upload; it counts as handed in once the file has landed. Hand in more than 24h after accepting and 30% comes off this card.",
    hintProductionNoClock: "Submit opens this card's own upload; it counts as handed in once the file has landed. No 24h clock runs on this card.",
    hintRevision: "No new version within 48h of the feedback and 30% comes off this card (50% if the card was also late).",

    giveBackError: "Could not give the card back - try again.",
    submitError: "Could not submit - try again.",
    checklistError: "Could not save that - try again.",
    flagItem: "Wrong?",
    flagItemAria: "Report this item as wrong: {item}",
    flaggedItem: "Reported",
    flagError: "Could not report that - try again.",
  },
  {
    back: "Dashboard",
    acceptedOn: "{brand} · angenommen {when}",
    chipInProduction: "In Arbeit",
    chipInRevision: "In Revision · Runde {round}",
    chipRequested: "★ Der Kunde hat dich angefragt",

    unavailableTitle: "Diese Card ist nicht verfügbar",
    unavailableBody: "Die Card ist vielleicht schon weiter, oder sie gehört nicht dir.",

    briefing: "Briefing",
    copyBriefing: "Briefing kopieren",
    copiedBriefing: "Kopiert",
    copyBriefingFailed: "Kopieren fehlgeschlagen",
    openAllSections: "Alle öffnen",
    closeAllSections: "Alle schließen",
    versionNote: "Versionshinweis",
    noteFromAditor: "Notiz von Aditor für {brand}",
    watchLoom: "Ansehen",

    assets: "Assets und Links",
    noAssets: "Keine Assets oder Links auf dieser Card.",
    attached: "An der Card angehängt",

    additionalInfo: "Weitere Informationen",
    recentlyDelivered: "Zuletzt gelieferte {brand}-Cards",

    yourCard: "Deine Card",
    rateStatic: "Statischer Satz",
    rateBrandFlat: "{brand}-Pauschale",
    rateLocked: "Dein Satz für diese Card",
    ratePending: "Preis folgt",
    typeFact: "Typ",
    lengthFact: "Länge",
    languageFact: "Sprache",
    lengthSeconds: "~{seconds} s",
    lengthHooks: "{hooks} x ~{seconds} s",

    leftHours: "noch {hours} h",
    leftUnderHour: "unter 1 h übrig",
    overdue: "Überfällig",
    graceLeft: "Upload-Kulanz, noch {minutes} Min.",
    dueOn: "Fällig {when}",
    revisionDueOn: "Revision fällig {when}",
    handedInOnTime: "Eingereicht {when}, pünktlich",
    handedInLate: "Eingereicht {when}, verspätet",

    checklistTitle: "Checkliste für diese Card",
    checklistCount: "{done} von {total}",
    requestedChangesTitle: "Gewünschte Änderungen",
    requestedChangesRound: "Runde {round}",
    clientComments: "{brand}s Kommentare in FreeFrame ↗",

    feedbackTitle: "Kommentare des Kunden zu dieser Card",
    feedbackLoading: "Kommentare des Kunden werden geladen…",
    feedbackEmpty: "Noch keine Kommentare des Kunden zu dieser Card.",
    feedbackUnavailable: "Die Kommentare des Kunden lassen sich gerade nicht laden. Lade die Seite gleich neu.",
    feedbackFreeframeHint: "Was der Kunde in FreeFrame markiert hat, steht unter Gewünschte Änderungen.",

    submit: "Zur Prüfung einreichen ↗",
    submitting: "Wird geöffnet…",
    giveBack: "Card zurückgeben",
    givingBack: "Wird zurückgegeben…",
    uploadNewVersion: "Neue Version hochladen ↗",
    uploading: "Wird geöffnet…",
    noHandinLink: "Für diese Card gibt es noch keinen Einreich-Link - frag Ops.",

    hintProduction: "Einreichen öffnet den Upload genau dieser Card; abgegeben ist sie erst, wenn die Datei angekommen ist. Reichst du mehr als 24 h nach der Annahme ein, kostet es 30 % dieser Card.",
    hintProductionNoClock: "Einreichen öffnet den Upload genau dieser Card; abgegeben ist sie erst, wenn die Datei angekommen ist. Auf dieser Card läuft keine 24-h-Frist.",
    hintRevision: "Keine neue Version innerhalb von 48 h nach dem Feedback kostet 30 % dieser Card (50 %, wenn die Card auch schon verspätet war).",

    giveBackError: "Die Card konnte nicht zurückgegeben werden - versuch es nochmal.",
    submitError: "Konnte nicht eingereicht werden - versuch es nochmal.",
    checklistError: "Konnte nicht gespeichert werden - versuch es nochmal.",
    flagItem: "Falsch?",
    flagItemAria: "Diesen Punkt als falsch melden: {item}",
    flaggedItem: "Gemeldet",
    flagError: "Konnte nicht gemeldet werden - versuch es nochmal.",
  },
);
